import React, { createContext, useContext } from 'react';
import { useGlobalPopup } from './Popuphook'; // Remove the extra './Popups/'
import Popup from './Popup'; // Remove the extra './Popups/'

const PopupContext = createContext();

export const usePopup = () => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error('usePopup must be used within a PopupProvider');
  }
  return context;
};

export const PopupProvider = ({ children }) => {
  const popupMethods = useGlobalPopup();

  // Override the global alert function
  React.useEffect(() => {
    // Store the original alert function
    const originalAlert = window.alert;
    
    // Replace alert with our custom popup
    window.alert = (message) => {
      popupMethods.customAlert(message);
    };

    // Cleanup: restore original alert when component unmounts
    return () => {
      window.alert = originalAlert;
    };
  }, [popupMethods]);

  return (
    <PopupContext.Provider value={popupMethods}>
      {children}
      <Popup
        isOpen={popupMethods.popup.isOpen}
        onClose={popupMethods.closePopup}
        type={popupMethods.popup.type}
        title={popupMethods.popup.title}
        message={popupMethods.popup.message}
      />
    </PopupContext.Provider>
  );
};